export default {
  validatePassword(password, t) {
      if (!password || password.length == 0) return t('required');
      if (password && password.length < 8) return t('password_too_short');
      return true;
  }
}


// WEBPACK FOOTER //
// ./src/passwordcomplexity.js